const cmpPhotoCarousel = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    const bootstrapSlides = _.component.querySelectorAll('.carousel-item.bg-light')
    const photobulletIndicator = _.component.querySelectorAll('.cmp-photo-carousel.carousel .glide__bullets .glide__bullet')
    const photoCarouselLoop = _.component.querySelector('.cmp-photo-carousel.carousel')

    if (bootstrapSlides.length > 0) {
      //console.log(photobulletIndicator)
      _.showBootStrapSlides(bootstrapSlides, photobulletIndicator)
    }
    _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').addEventListener("click", function (event) {
      let oldSlideContent = _.component.querySelector('.cmp-photo-carousel__slide.active')
      //console.log(oldSlideContent)
      if (photoCarouselLoop.getAttribute("data-loop") == 'True') {
        if (oldSlideContent != null) {
          //console.log(oldSlideContent)
          oldSlideContent.classList.remove('active')
        }
        let activeBootStrapSlideItem = oldSlideContent.previousElementSibling
        if (activeBootStrapSlideItem != null) {
          // animate content
          activeBootStrapSlideItem.classList.add('active')
        }
        else {
          let parentNode = oldSlideContent.parentNode
          activeBootStrapSlideItem = parentNode.lastElementChild
          activeBootStrapSlideItem.classList.add('active')
        }
      }
      else {
        let activeBootStrapSlideItem = oldSlideContent.previousElementSibling
        if (activeBootStrapSlideItem != null) {
          // animate content
          oldSlideContent.classList.remove('active')
          activeBootStrapSlideItem.classList.add('active')
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--right').disabled = false
        }
        else {
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').disabled = true
        }
        if (activeBootStrapSlideItem != null && activeBootStrapSlideItem.previousElementSibling == null) {
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').disabled = true
        }
        else if(oldSlideContent.previousElementSibling == null){
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').disabled = true
        }
        else {
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').disabled = false
        }
      }
    })
    _.component.querySelector('.cmp-photo-carousel .glide__arrow--right').addEventListener("click", function (event) {
      let oldSlideContent = _.component.querySelector('.cmp-photo-carousel__slide.active')
      if (photoCarouselLoop.getAttribute("data-loop") == 'True') {
        if (oldSlideContent != null) {
          //console.log(oldSlideContent)
          oldSlideContent.classList.remove('active')
        }
        let activeBootStrapSlideItem = oldSlideContent.nextElementSibling
        if (activeBootStrapSlideItem != null) {
          // animate content
          activeBootStrapSlideItem.classList.add('active')
        }
        else {
          let parentNode = oldSlideContent.parentNode
          activeBootStrapSlideItem = parentNode.firstElementChild
          activeBootStrapSlideItem.classList.add('active')
        }
      }
      else {
        let activeBootStrapSlideItem = oldSlideContent.nextElementSibling
        if (activeBootStrapSlideItem != null) {
          // animate content
          oldSlideContent.classList.remove('active')
          activeBootStrapSlideItem.classList.add('active')
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--left').disabled = false
        }
        if (activeBootStrapSlideItem != null && activeBootStrapSlideItem.nextElementSibling == null) {
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--right').disabled = true
        }
        else {
          _.component.querySelector('.cmp-photo-carousel .glide__arrow--right').disabled = false
        }
      }
    })
  },

  showBootStrapSlides: function (bootstrapSlides, bulletIndicator) {
    const activeBootStrapSlide = bootstrapSlides[0]
    activeBootStrapSlide.classList.add('active')
    //activate bullet
    const activeBullet = bulletIndicator[0]
    if (activeBullet != null) {
      activeBullet.classList.add('active')
    }
  }
}

export default cmpPhotoCarousel
